import React from 'react';
import Modal from '../../components/Modals/Modal';
import WarningIcon from '../../components/Icons/outline/WarningIcon';
import SecondaryButton from '../../components/Buttons/SecondaryButton';
import RedButton from '../../components/Buttons/RedButton';
import { COLORS } from '../../config';

function DeleteUserModal({
  showDeleteUserModal,
  setShowDeleteUserModal,
  onDelete,
  forceDelete
}) {

  const handleHide = () => {
    setShowDeleteUserModal(false)
  }

  const handleDelete = () => {
    onDelete();
    setShowDeleteUserModal(false);
  }
  
  return (
    <Modal className='min-w-1/2' title={'Warning'} show={showDeleteUserModal} hide={handleHide}>
      <div className='flex flex-col justify-between my-8'>
        <WarningIcon className='h-12 w-12 self-center mb-4 -mt-4' stroke={ COLORS.deleteRed } />
        {!forceDelete ?
        <>
          <p className='mb-4'>
            Deleting this user will remove him from the platform. He will not be able to login, and he will be removed from all ongoing treatments and associated clinics.
          </p>
          <p>
            Only the root user will be able to revert this action. Are you sure you want to proceed?
          </p>
        </>
        :
        <>
          <p className='mb-4 text-center'>
            <strong>PROCEED WITH CAUTION.</strong>
          </p>
          <p className='mb-4'>
            You are about to complete erase this user from the database.
          </p>
          <p>
            All of the user's associated data will be erased completely, and it will not be able to retrieve it. Are you sure you want to proceed?
          </p>
        </>
        }
      </div>
      <div className='grid grid-cols-2 gap-x-2'>
        <SecondaryButton onClick={handleHide} text='Cancel'/>
        <RedButton text={forceDelete ? 'Erase user' : 'Delete user'} onClick={handleDelete} />
      </div>
    </Modal>
  )
}

export default DeleteUserModal
